// auth.service.js
import api from './api';

export const authService = {
  /* Sign in. `tenant` is sent only after the gateway answered
     schoolChoiceRequired and the person picked a school — a first attempt
     goes without it, and the gateway resolves the school from the email. */
  async login(email, password, tenant) {
    const response = await api.post('/auth/login', tenant ? { email, password, tenant } : { email, password });
    const data = response.data.data || {};

    // Two schools know this person; nothing was issued yet. The caller shows
    // the choice and calls again with the chosen tenant slug.
    if (data.schoolChoiceRequired) return response.data;

    if (data.token) {
      localStorage.setItem('token', data.token);
      if (data.refreshToken) localStorage.setItem('refreshToken', data.refreshToken);
      localStorage.setItem('user', JSON.stringify(data.user));
      return response.data;
    }
    throw new Error('Login failed');
  },

  /* Every school where this email has an active profile —
     [{tenant, name, current}]. Powers the switcher in the sidebar. */
  async profiles() {
    const response = await api.get('/auth/profiles');
    return response.data.data || [];
  },

  /* Move this session to another school. Proof is the live refresh token —
     no password retyped. Stores the fresh tokens for the target school. */
  async switchSchool(tenant) {
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) throw new Error('No session to switch — sign in again.');
    const response = await api.post('/auth/switch', { refreshToken, tenant });
    const data = response.data.data || {};
    if (!data.token) throw new Error('Switch failed');
    localStorage.setItem('token', data.token);
    if (data.refreshToken) localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('user', JSON.stringify(data.user));
    return data;
  },

  /* No register or forgotPassword. Both endpoints are gone from the API:
     accounts for the whole estate are created by an administrator in the Auth
     Gateway, and password resets happen there too. */

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
  }
};
